import { Link } from 'react-router-dom';

const categories = [
  {
    slug: 'movie',
    label: '电影',
    icon: 'ri-film-line',
    color: 'bg-primary-500',
    desc: '热门大片 · 院线新片',
  },
  {
    slug: 'tv',
    label: '电视剧',
    icon: 'ri-tv-line',
    color: 'bg-accent-500',
    desc: '热播剧集 · 高分神剧',
  },
  {
    slug: 'variety',
    label: '综艺',
    icon: 'ri-emotion-laugh-line',
    color: 'bg-secondary-500',
    desc: '热门综艺 · 欢乐不停',
  },
  {
    slug: 'anime',
    label: '动漫',
    icon: 'ri-rocket-line',
    color: 'bg-primary-600',
    desc: '国漫精品 · 日漫经典',
  },
];

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-6">
          分类导航
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-lg p-5 md:p-6 bg-background-100 hover:bg-background-200 cursor-pointer transition-all duration-300"
            >
              <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg ${cat.color} flex items-center justify-center mb-3 md:mb-4`}>
                <i className={`${cat.icon} text-white text-lg md:text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {cat.label}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">{cat.desc}</p>
              <div className={`absolute bottom-0 left-0 right-0 h-0.5 ${cat.color} transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left`} />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}